import { render, staticRenderFns } from "./MailNew.vue?vue&type=template&id=0b407ace&scoped=true&"
import script from "./MailNew.vue?vue&type=script&lang=js&"
export * from "./MailNew.vue?vue&type=script&lang=js&"
import style0 from "./MailNew.vue?vue&type=style&index=0&id=0b407ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b407ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b407ace')) {
      api.createRecord('0b407ace', component.options)
    } else {
      api.reload('0b407ace', component.options)
    }
    module.hot.accept("./MailNew.vue?vue&type=template&id=0b407ace&scoped=true&", function () {
      api.rerender('0b407ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/mails/MailNew.vue"
export default component.exports